import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(<App />, document.getElementById('root'))

// Register the service worker so the app works offline and loads faster on
// repeat visits. Registration is a no-op outside production builds.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()
